import { onReady } from './util/onReady';

const items_to_load = 5;

onReady(() => {
    setupLoadMore();
    setupAccordion();
    setupContributorToggle();
});

/**
 * Load More Controller
 */
function setupLoadMore() {
    const nvaContainer = document.querySelector('.nva-publications');
    if (!nvaContainer) return;

    const loadMoreButtons = nvaContainer.querySelectorAll<HTMLButtonElement>('.loadMoreButton');

    loadMoreButtons.forEach((button) => {
        button.addEventListener('click', () => {
            const targetId = button.dataset.controls;
            if (!targetId) return;

            const container = document.getElementById(targetId);
            if (!container) return;

            const offset = parseInt(container.dataset.offset || items_to_load.toString());
            const publications = Array.from(container.children);
            const total = publications.length;

            // Show next 5
            for (let i = offset; i < offset + items_to_load && i < total; i++) {
                (publications[i] as HTMLElement).classList.remove('hide');
            }

            const newOffset = offset + items_to_load;
            container.dataset.offset = newOffset.toString();

            // Update count
            const countElement = document.getElementById(`${targetId}-count`);
            if (countElement) countElement.textContent = Math.min(newOffset, total).toString();

            // Hide button if all shown
            if (newOffset >= total) button.classList.add('hide');
        });
    });
}

/**
 * Accordion Controller
 */
function setupAccordion() {
    const nvaContainer = document.querySelector('.nva-publications') || document.querySelector('.nva-departments');
    if (!nvaContainer) return;

    const buttons = nvaContainer.querySelectorAll<HTMLButtonElement>('.accordion-button-container');

    buttons.forEach((button) => {
        button.addEventListener('click', () => {
            const targetId = button.getAttribute('aria-controls');
            if (!targetId) return;

            const element = document.getElementById(targetId);
            if (!element) return;

            const isHidden = element.classList.contains('hide');
            element.classList.toggle('hide');

            button.setAttribute('aria-expanded', isHidden.toString());
            const newLabel = isHidden ? button.dataset.hideSummary : button.dataset.showSummary;
            if (newLabel) button.setAttribute('aria-label', newLabel);
        });
    });
}

function setupContributorToggle() {
    const nvaContainer = document.querySelector('.nva-publications') || document.querySelector('.nva-departments');
    if (!nvaContainer) return;

    const links = nvaContainer.querySelectorAll<HTMLElement>('.contributorsLink');

    links.forEach((link) => {
        const targetId = link.getAttribute('aria-controls');
        if (!targetId) return;

        const extraContributors = document.getElementById(targetId);
        const dots = document.getElementById(targetId + 'Dot');

        if (!extraContributors) return;

        link.addEventListener('click', (e) => {
            e.preventDefault();
            if (dots) dots.classList.toggle('hide');
            extraContributors.classList.toggle('hide');
            const isExpanded = !extraContributors.classList.contains('hide');

            // Update aria-expanded for accessibility
            link.setAttribute('aria-expanded', isExpanded.toString());

            // Update link text based on state
            const newLabel = isExpanded ? link.dataset.hideContributors : link.dataset.showContributors;
            if (newLabel) link.textContent = newLabel;
        });
    });
}
